import { useEffect, useState } from "react";
import { airports as list } from "../assets/airports2";
import { filter, forIn, groupBy, includes, orderBy, slice } from "lodash";
import { ANY_AIRPORT } from "../components/Constants";

export default function useAirports() {
  const [airports, setAirports] = useState([]);

  const getAirports = (searchText) => {
    const lowerCaseText = searchText?.toLowerCase() || '';
    let arr0 = filter(
      list,
      (value) =>
        !!value.iata &&
        (searchText
          ? includes(value.iata?.toLowerCase(), lowerCaseText) ||
            includes(value.name?.toLowerCase(), lowerCaseText) ||
            includes(value.city?.toLowerCase(), lowerCaseText) ||
            includes(value.country?.toLowerCase(), lowerCaseText)
          : true)
    );
    arr0 = orderBy(arr0, ['country', 'city']);

    const arr = groupBy(arr0, "country");

    const arr2 = {};
    forIn(arr, (cities, country) => (arr2[country] = groupBy(cities, "city")));

    forIn(arr2, (cities, country) => {
      forIn(cities, (values, city) => {
        arr2[country][city] = [{ type: 'any', city, country, name: `${city} - ${ANY_AIRPORT}` }, ...values];
      });
    });

    let arr4 = [];
    forIn(arr2, (cities, country) => {
      arr4.push({ name: country, type: 'country' });
      forIn(cities, (airports, cityName) => {
        arr4 = arr4.concat(airports);
      })
    });

    arr4 = slice(arr4, 0, 10)

    setAirports(arr4);
  };

  useEffect(() => {
    getAirports();
  }, []);

  return {
    airports,
    getAirports,
  };
}
